import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  CourseCategory,
  CourseItem,
  CourseResponseDTO,
  ICourseDTO,
  ICourseContentDTO,
} from './models';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class CourseService {
  private http = inject(HttpClient);

  private baseUrl = environment.host;

  getAll(page: number, limit = 10, status?: string, includeUnlisted?: boolean) {
    let url = this.baseUrl + '/api/v1/course?page=' + page + '&limit=' + limit;
    if (status) url += '&status=' + encodeURIComponent(status);
    if (includeUnlisted) url += '&includeUnlisted=true';
    return this.http.get<CourseResponseDTO>(url);
  }

  getAllForInstructor() {
    return this.http.get<CourseResponseDTO>(
      this.baseUrl + '/api/v1/course/instructor',
    );
  }

  getById(id: string) {
    return this.http.get<CourseItem>(this.baseUrl + '/api/v1/course/' + id);
  }

  create(courseDTO: ICourseDTO) {
    return this.http.post<CourseItem>(
      this.baseUrl + '/api/v1/course',
      courseDTO,
    );
  }

  update(courseId: string, courseDTO: ICourseDTO) {
    return this.http.put<CourseItem>(
      this.baseUrl + '/api/v1/course/' + courseId,
      courseDTO,
    );
  }

  updateContents(courseId: string, courseContentsDTO: ICourseContentDTO[]) {
    return this.http.put<CourseItem>(
      this.baseUrl + '/api/v1/course/' + courseId + '/contents',
      courseContentsDTO,
    );
  }

  getAllCategories() {
    return this.http.get<CourseCategory[]>(this.baseUrl + '/api/v1/categories');
  }

  getEnrollments() {
    return this.http.get<CourseItem[]>(
      this.baseUrl + '/api/v1/course/enrollments',
    );
  }

  requestForReview(id: string) {
    return this.http.put<CourseItem>(
      this.baseUrl + '/api/v1/course/' + id + '/submit',
      {},
    );
  }

  publish(id: string) {
    return this.http.put<CourseItem>(
      this.baseUrl + '/api/v1/course/' + id + '/publish',
      {},
    );
  }

  enrollStudent(
    courseId: string,
    payload: { studentId: string; expiresInDays?: number },
  ) {
    return this.http.post<any>(
      this.baseUrl + '/api/v1/course/' + courseId + '/enroll',
      payload,
    );
  }

  unenrollStudent(courseId: string, studentId: string) {
    return this.http.delete<any>(
      this.baseUrl + '/api/v1/course/' + courseId + '/enroll/' + studentId,
    );
  }
}
